// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__14j39","importantInfo":"styles_importantInfo__2k_6n"};